const AccountDisabledPage = () => {
  return (
    <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Wrapper */}
        <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
          <div className="card-header">
            <div className="card-title m-0">
              <h3 className="fw-bolder m-0">Account Disabled</h3>
            </div>
          </div>
          <div className="card-body border-top p-9 d-flex flex-column gap-4">
            <div>This account has been disabled. If you think this is a mistake, contact your property manager.</div>
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  );
};

export default AccountDisabledPage;
